import React, { useState, useEffect } from "react";
import DataHelper from "../../DataHelper";
import Alert from "../Alert";
import FieldSet from "../FieldSet";
import Modal from "../Modal";
import Slider from "../Slider";
import GridPicker from "../GridPicker";

interface IProps {
  games: IGames;
  game: IGame;
  open: boolean;
  onClose: () => void;
  onApply: (settings: ISettings) => void;
  settings: ISettings;
}
const GameCardSettingsModal = ({
  games,
  game,
  open = false,
  onClose = () => {},
  onApply = (settings: ISettings) => {},
  settings: settingsIn,
}: IProps) => {
  const data = new DataHelper(games);
  const parents = data
    .getParentGames(game)
    .sort((a: IGame, b: IGame) => (a.title <= b.title ? -1 : 1)) as IGame[];
  const [settings, setSettings] = useState(settingsIn);

  const onModalClose = () => {
    //totally not prop drilling
    onClose();
  };

  const onApplyClick = (e: any) => {
    onApply(settings);
    onClose();
  };

  const findParentSettingsIndex = (key: string) =>
    settings.parents.findIndex((p) => p.key === key);

  const updateParentRatio = (key: string, ratio: number) => {
    const index = findParentSettingsIndex(key);

    setSettings((prevSettings) => {
      const { parents: prevParents } = prevSettings;

      return {
        ...prevSettings,
        parents: [
          ...prevParents.slice(0, index),
          {
            key,
            ratio,
          },
          ...prevParents.slice(index + 1),
        ],
      };
    });
  };
  return (
    <div className="GameSettingsModal">
      <Modal
        open={open}
        title="Settings"
        showButton={false}
        onClose={onModalClose}
      >
        <FieldSet legend="Parent Rules Settings">
          Adjust these sliders to control the likelihood of each parent game's
          rules being on the board. The higher the slider, the more rules from
          that game will be on the board
          <ul className="GameCardSettingsModal__parent-rules-sliders">
            {parents.map((parent: IGame, i: number) => {
              const parentGame = settings.parents.find(
                (p) => p.key === parent.gameKey
              );
              const startingRatio = parentGame ? parentGame.ratio : 1;

              return (
                parent.rules &&
                Object.keys(parent.rules).length > 0 && (
                  <li key={i}>
                    <Slider
                      title={parent.title}
                      startingValue={startingRatio}
                      max={5}
                      onChange={(val) => {
                        updateParentRatio(parent.gameKey, val);
                      }}
                    />
                  </li>
                )
              );
            })}
          </ul>
        </FieldSet>
        {/* <FieldSet
          legend="Board Size"
          className="GameCardSettingsModal__grid-size"
        >
          Choose the size of the bingo
          <br /> grid you want to play with
          <GridPicker
            size={settings.grid}
            onChange={(grid: Array<number>) => {
              setSettings((oldSettings) => {
                return {
                  ...oldSettings,
                  grid,
                };
              });
            }}
          />
        </FieldSet> */}
        <FieldSet
          legend="Scoring Legend"
          className="GameCardSettingsModal__scoring"
        >
          <dl>
            <dt>1</dt>
            <dd>Happens frequently</dd>
            <dt>2</dt>
            <dd>Happens a few times</dd>
            <dt>3</dt>
            <dd>Happens a couple times</dd>
            <dt>4</dt>
            <dd>Happens 1 - 2 times</dd>
            <dt>5</dt>
            <dd>Happens 0 - 1 times, closer to 1</dd>
            <dt>6</dt>
            <dd>Happens 0 - 1 times, closer to 0</dd>
            <dt>7</dt>
            <dd>
              It'll never happen! ...until it does.{" "}
              <small>Think of this as a "finish your drink"</small>
            </dd>
          </dl>
        </FieldSet>
        <footer className="GameCardSettingsModal__footer">
          <Alert type="info">Clicking Apply will refresh the board</Alert>
          <button
            className="cta GameCardSettingsModal__apply"
            onClick={onApplyClick}
          >
            Apply
          </button>
        </footer>
      </Modal>
    </div>
  );
};

export default GameCardSettingsModal;
